import { CSSGrid } from 'components/UI/CSSGrid';
import styled from 'styled-components';

export const AnalysisColumn = styled(CSSGrid.Col)`
	padding: 0.4rem;
`;
